import { OverlayNavigator } from '@carboncopyco/components';
import { useLazyGetDemoQuery } from '@carboncopyco/data';
import type { IGlobalTab } from '@carboncopyco/types/desktop';
import { MemoryRouter, Route, Routes } from 'react-router-dom';
import Navigation from '../../components/Navigation/Navigation';
import { useOpenDemoEditorTab } from '../../screens/utils/openDemoEditorTab';
import { useTabManager } from '../../services/TabManager';
import { useUser } from '../../store/context/UserContext';
import { useWorkspaces } from '../../store/context/WorkspaceContext';
import { RumRouteTracker } from '../../shared/RumRouteTracker';

interface NewCloneProps {
  tab: IGlobalTab;
  onUrlSelect: () => void;
}

const OverlayRoute = ({ tab, onUrlSelect }: NewCloneProps) => {
  const { activeOrganization } = useUser();
  const { activeWorkspace, defaultWorkspace } = useWorkspaces();
  const { closeGlobalTab } = useTabManager();
  const organizationId = activeOrganization?.id.toString() || '';
  const workspaceId = activeWorkspace.current.id || defaultWorkspace?.id || '';

  const [getDemo] = useLazyGetDemoQuery();
  const openDemoEditorTab = useOpenDemoEditorTab();

  const handleGoToEditor = async ({ id }: { id: number }) => {
    if (organizationId) {
      const demo = await getDemo({
        workspaceId,
        organizationId,
        id: id.toString(),
        removeDeleted: true,
      }).unwrap();
      closeGlobalTab(tab.id);
      openDemoEditorTab(demo, Number(organizationId));
      onUrlSelect();
    }
  };

  return (
    <div className="relative landing-page flex flex-col flex-grow flex-shrink basis-0 min-h-0 bg-white">
      <Navigation showDashboardButton />
      <div className="flex-auto flex items-center justify-center relative overflow-hidden">
        {defaultWorkspace?.id && (
          <OverlayNavigator
            workspaceId={String(workspaceId)}
            organizationId={organizationId}
            goToEditor={handleGoToEditor}
          />
        )}
      </div>
    </div>
  );
};

const OverlayScreen = ({ tab, onUrlSelect }: NewCloneProps) => {
  let initialRoute = '';
  if (tab.folderId) {
    initialRoute = `/folder/${tab.folderId}/demo/new`;
  }

  return (
    <MemoryRouter initialEntries={[initialRoute]}>
      <RumRouteTracker />
      <Routes>
        <Route
          path="/folder/:folderId/demo/new"
          element={
            <OverlayRoute
              tab={tab}
              onUrlSelect={onUrlSelect}
            />
          }
        />
        <Route
          path="/*"
          element={
            <OverlayRoute
              tab={tab}
              onUrlSelect={onUrlSelect}
            />
          }
        />
      </Routes>
    </MemoryRouter>
  );
};

export default OverlayScreen;
